// extracted by mini-css-extract-plugin
export default {"root":"Informer__root--BCyNo","icon":"Informer__icon--2KMQT"};